//  1)  If we find a #ghost-nav-sentinel use an IntersectionObserver.
//  2)  Otherwise we detect whichever element actually scrolls and watch it.
//  3)  Hovering the header forces the solid color background until the pointer leaves.

(() => {
  const root = document.documentElement;
  if (root.dataset.ghostNavEnabled !== 'true') return; // metafield enables ghost nav

  // helper to flip the attribute
  const enable = on =>
    root.setAttribute('data-ghost-nav-enabled', on ? 'true' : 'false');

  //  sentinel branch (marketing pages)
  const sentinel = document.getElementById('ghost-nav-sentinel');
  const header   = document.querySelector('.header-wrapper');

  if (sentinel && header) {
    const makeIO = () =>
      new IntersectionObserver(
        ([entry]) => enable(entry.isIntersecting),
        {
          threshold  : 0,
          rootMargin : `-${header.getBoundingClientRect().height}px 0px 0px 0px`
        }
      );

    let io = makeIO();
    io.observe(sentinel);

    // keep IO in-sync if the sticky header changes height
    addEventListener('resize', () => {
      io.disconnect();
      io = makeIO();
      io.observe(sentinel);
    });

    // initial state
    enable(true);
  }

  // scrolling-element branch (Searchspring PLP)
  else {
    // find the first element that really scrolls
    const findScroller = () => {
      const main = document.getElementById('MainContent');
      if (main && main.scrollHeight > main.clientHeight) return main;

      // walk down through <body> children
      for (const el of document.body.children) {
        if (el.scrollHeight > el.clientHeight) return el;
      }
      return window;
    };

    const scroller = findScroller();
    const atTop    =
      scroller === window
        ? () => window.scrollY <= 1
        : () => scroller.scrollTop <= 1;

    // throttle with rAF
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          enable(atTop());
          ticking = false;
        });
        ticking = true;
      }
    };
    scroller.addEventListener('scroll', onScroll, { passive: true });

    enable(atTop()); // set once before first paint
  }

  // hover-to-solid fallback (simpler & reliable)
  // Works for *both* sentinel pages and PLP pages.

  const hdrSel =
    '.header-wrapper, .contentfulHeader-DesktopMenu, .shopify-section-header-sticky';

  // Pick all header-like elements once (there can be two when using a portal)
  document.querySelectorAll(hdrSel).forEach((hdr) => {
    /* pointer enters header  → always go solid */
    hdr.addEventListener(
      'mouseover',
      () => enable(false),
      { passive: true }
    );

    // pointer leaves header - restore ghost if truly at top
    hdr.addEventListener(
      'mouseleave',
      () => {
        /* If we’re in the scroller branch use atTop();  
          otherwise (sentinel branch) falling back to window.scrollY is fine. */
        const shouldBeGhost =
          typeof atTop === 'function' ? atTop() : window.scrollY <= 1;

        enable(shouldBeGhost);
      },
      { passive: true }
    );
  });

  function setGhostNavTheme(theme) {
    if (theme == 'light' || theme == 'dark') {
      document.documentElement.setAttribute('data-ghost-nav-theme', theme);
    }
  }

  window.addEventListener('ghost-nav-theme', (e) => setGhostNavTheme(e.detail));

  function setGhostNavTheme(theme) {
  console.log('Setting ghost nav theme to:', theme);
  if (theme == 'light' || theme == 'dark') {
    document.documentElement.setAttribute('data-ghost-nav-theme', theme);
  }
}
})();